/**
 * Compte à rebours ouverture — fuseau Europe/Paris.
 * Redirige vers redirect_url une fois la date atteinte (hors éditeur de thème).
 */
class LaunchCountdown extends HTMLElement {
  #timer;
  #armRedirect = false;

  connectedCallback() {
    const target = this.#getTargetMs();
    // N'armer la redirection que si l'ouverture est encore À VENIR au chargement.
    // Si la date est déjà passée quand la page se charge, on NE redirige PAS : la
    // visiteuse est encore sur cette page (boutique toujours verrouillée), donc
    // rediriger vers redirect_url ne ferait que reboucler ici → chargement infini.
    // On ne redirige que si le rebours atteint zéro pendant que la page est ouverte.
    this.#armRedirect = !Number.isNaN(target) && target - Date.now() > 0;
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #getTargetMs() {
    const y = Number(this.dataset.year);
    const m = Number(this.dataset.month);
    const d = Number(this.dataset.day);
    const h = Number(this.dataset.hour);
    const min = Number(this.dataset.minute);

    if (!y || !m || !d) return NaN;

    // Été : CEST (UTC+2) — suffisant pour une date fixe en juillet à Paris.
    const iso = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}T${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}:00+02:00`;
    return new Date(iso).getTime();
  }

  #tick() {
    const target = this.#getTargetMs();
    const now = Date.now();
    let diff = target - now;

    if (Number.isNaN(target)) return;

    if (diff <= 0) {
      this.#setUnit('days', 0);
      this.#setUnit('hours', 0);
      this.#setUnit('minutes', 0);
      this.#setUnit('seconds', 0);
      this.classList.add('is-complete');

      const redirect = this.dataset.redirect;
      const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');
      if (this.#armRedirect && redirect && !isDesignMode) {
        window.location.replace(redirect);
      }
      return;
    }

    const days = Math.floor(diff / 86400000);
    diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);

    this.#setUnit('days', days);
    this.#setUnit('hours', hours);
    this.#setUnit('minutes', minutes);
    this.#setUnit('seconds', seconds);
  }

  #setUnit(name, value) {
    const node = this.querySelector(`[data-unit="${name}"]`);
    if (node) node.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('launch-countdown')) {
  customElements.define('launch-countdown', LaunchCountdown);
}
